module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-24-7f50b13f66a9b5a553f28d03181927d0.png";